import { IconProps } from "../../utils/global-types/global-types";

const UnionIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M10.17 10.227a3.43 3.43 0 0 1 3.429 3.427v.686a1.373 1.373 0 0 1-1.372 1.372H5.371A1.37 1.37 0 0 1 4 14.34v-.686a3.43 3.43 0 0 1 3.428-3.427zM8.799 2A3.428 3.428 0 1 1 5.37 5.428l.003-.149A3.43 3.43 0 0 1 8.798 2"
    ></path>
  </svg>
);

export default UnionIcon;
